module.exports = __webpack_public_path__ + "235cbe6e345a5cf927d029f4b071efb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/denim-jacket.png
// module id = 1262
// module chunks = 0